import { ChangeDetectionStrategy,  Component, Inject, input } from '@angular/core';

import { FieldOkItemComponent } from '@softline/dynamic';
import { IsDefinedNotEmptyPipe } from '@softline/ui-core';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'soft-ktostamm-kunde-subnummer-field-ok-data-view',
  imports: [IsDefinedNotEmptyPipe],
  templateUrl: './ktostamm-kunde-subnummer.list-view.html',
  styleUrls: ['./ktostamm-kunde-subnummer.list-view.css'],
})
export class KtostammKundeSubnummerListView implements FieldOkItemComponent<any> {
  readonly item = input<any>();

  constructor() {}
}
